import React, {Component, Fragment, useEffect, useRef, useState} from 'react'
import {t} from "@lingui/core/macro"

export default function DonationButton({context,campagneData,campagneTarget,onClick,style})
{

    const defaultOnClick=()=>{
        // Le bloc de don en ligne (#modal-don) n'est rendu que par la section PRODUCTS
        // du gabarit par défaut : s'il est absent (section masquée, gabarit ald…), on
        // ouvre la fenêtre de don au lieu de laisser le bouton sans effet.
        const inlineDon = campagneData?.config?.noModal ? document.getElementById("modal-don") : null
        if(inlineDon){
            window.scrollTo(0, inlineDon.offsetTop-100);
        }else{
            context?.actions?.showModalDon?.()
        }
    }

    const text=campagneData?.config?.donationButtonText || t`Faire un don`

    return(
        <div className={"donation-button"} style={style} onClick={() => onClick?onClick():defaultOnClick()}>{text}</div>
    )
}
